<template>
  <div class="banner-container">
    <div class="row mx-0">
      <div
        v-for="(item, index) in dhsItems"
        class="dhs-card px-1"
        :class="[dhsCardClasses, { 'd-none': index + 1 > maxCardCount }]"
        :key="item.spotlight.internalName"
        ref="dhsCard"
      >
        <SpotlightDHSHeroCard v-if="item.isHero" class="mb-2" :spotlight="item.spotlight"></SpotlightDHSHeroCard>
        <SpotlightDHSCard v-else class="mb-2" :spotlight="item.spotlight"></SpotlightDHSCard>
      </div>
    </div>
    <template v-if="showToggleButton">
      <button
        :aria-label="isOpen ? $t(`message.DHS.ariaLabel.viewLess`) : $t(`message.DHS.ariaLabel.viewMore`)"
        type="button"
        class="toggle-button mt-3"
        :class="{ 'is-open': isOpen }"
        @click="clickToggleButton"
        data-test="toggleButton"
      >
        <font-awesome-icon :icon="['far', 'chevron-down']" class="toggle-icon"></font-awesome-icon>
      </button>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const SpotlightDHSHeroCard = () => import('@/modules/spotlight/components/SpotlightDHSHeroCard.vue');
const SpotlightDHSCard = () => import('@/modules/spotlight/components/SpotlightDHSCard.vue');

export default {
  name: 'SpotlightDHSBanner',
  components: {
    SpotlightDHSHeroCard,
    SpotlightDHSCard,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters('spotlight', ['totalSpotlightCardCount', 'getSpotlightHeroes', 'getSpotlightCategories']),
    showToggleButton() {
      return this.currentScreenMediaQuery === 'desktop'
        ? this.totalSpotlightCardCount > 3
        : this.totalSpotlightCardCount > 2;
    },
    dhsCardClasses() {
      return this.totalSpotlightCardCount > 1 ? 'col-6 col-sm-4' : 'col';
    },
    maxCardCount() {
      return this.currentScreenMediaQuery === 'desktop' ? 3 : 2;
    },
    dhsItems() {
      return [
        ...this.getSpotlightHeroes.map(spotlight => ({ spotlight, isHero: true })),
        ...this.getSpotlightCategories.map(spotlight => ({ spotlight, isHero: false })),
      ];
    },
  },
  watch: {
    currentScreenMediaQuery() {
      this.isOpen = false;
      this.toggleCard();
    },
  },
  methods: {
    clickToggleButton() {
      this.isOpen = !this.isOpen;
      this.toggleCard();
    },
    toggleCard() {
      const dhsCards = this.$refs.dhsCard;
      if (dhsCards) {
        dhsCards.forEach((card, index) => {
          if (this.isOpen) {
            card.classList.remove('d-none');
          } else if (index + 1 > this.maxCardCount) {
            card.classList.add('d-none');
          } else {
            card.classList.remove('d-none');
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.toggle-button {
  width: 100%;
  background-color: #dae2ea;
  border: none;
  border-radius: 5px;
  padding: 7px 0;

  .toggle-icon {
    transition: transform 0.4s ease;
  }

  &.is-open {
    .toggle-icon {
      transform: rotate(-180deg);
    }
  }
}
</style>
